import { Chakra } from "@airhelp/react-ui-components";
import config from "config/config";
import { useTranslations } from "contexts/LocalizationContext/hooks";
import { APRA_LINK } from "../../consts";

const { Flex, Image, Link, Text } = Chakra;

const TrustSection = () => {
  const translations = useTranslations();

  return (
    <Flex
      py={{ base: 8, md: 6 }}
      align={{ base: "start", md: "center" }}
      flexDir={{ base: "column", md: "row" }}
      justify="space-between"
      borderBottom="1px solid"
      borderColor="greyscale.400"
    >
      <Flex flexDir={{ base: "column", md: "row" }} my={3}>
        <Link isExternal href={APRA_LINK} title={translations("alt_logo_apra")}>
          <Image
            src={`${config.staticUrl}/i/airhelp-plus/apra-logo.svg`}
            alt={translations("alt_logo_apra")}
            w="163px"
            maxW="initial"
            mr={8}
            mb={{ base: 4, md: 0 }}
          />
        </Link>
        <Text color="greyscale.600" fontSize="sm" alignSelf="center" w={{ base: "full", lg: "45%" }}>
          {translations("footer_airhelp_is_part")}
        </Text>
      </Flex>
    </Flex>
  );
};

export default TrustSection;
